import React from 'react'

import './styles.scss'
import ButtonRounded from 'components/ButtonRounded'

const ButtonApplePay = props => (
  <ButtonRounded
    icon="apple_pay"
    as="button"
    bgClassName="bg--black"
    wrapperClassName="btn--payment"
    iconColor="transparent"
    wrapperProps={props}
  />
)

export default ButtonApplePay
